import { getAppState } from "../../state";
import { getRouteByPath, routes, sections } from "../../routes";
import { config } from "../../config/config";
import { trackEvent } from "../../services/analyticsService";
import getBrands from "../../services/layoutService";
import { i18n } from "../../services/i18nService";
import { isLowEndLG } from "../../utils/checkLgNewModel";
export default function(currentProfile, redirectToPinLockForKids = null) {
  const userLogged = getAppState().userLogged;
  let subscriptionInactive = false;
  if (userLogged) {
    const subscriptions = getBrands("ACTIVE");
    subscriptionInactive = subscriptions && subscriptions.length > 0 ? true : false;
  }
  const isKids = currentProfile?.profileCategory === "KIDS" || false;
  const defaultAvatar = "https://starzplay-prod-ssl.akamaized.net/prd-peg-data/default/images/profiles/avatars/1.png";
  /**
   * The list of items to display in the main menu of the application.
   * @type {Object[]} An array of objects that can contain a set of properties.
   * - path: A path to which the application will have to go if this item is selected.
   * - name: (optional) The title to be displayed on the item (mandatory if icon not provided).
   * - icon: (optional) An icon to be displayed on the item, instead of a text (mandatory if name not provided).
   * - show: (optional) A boolean value that specifies if the item should be visible or not. Default is true.
   * - sticky: (optional) A boolean value that specifies if the app should keep the item selected when coming back from
   *   the section it sends the app to when selected.
   */
  const firstSection = [
    {
      path: routes.profileSelector,
      name: `Multi Profile`,
      customTranslation: currentProfile?.profileName || "You",
      secondLevelTitle: `${i18n.get("global.sections.switchProfiles")}`,
      icon: currentProfile?.avatar ? "mpPicture" : "settings",
      background: currentProfile?.avatar || defaultAvatar,
      visibleOnMenuExpand: true,
      separator: subscriptionInactive ? (userLogged ? true : false) : isKids ? true : false,
      listStyle: "switchprofile-icon",
      seperatorBottom: "-0.5rem",
      showInSection: 1,
      onClick: async function profileSelector(e) {
        trackEvent("switch_profile_clicked", null, "MP", currentProfile);
        if (currentProfile?.isKidLockEnabled && redirectToPinLockForKids) {
          e.preventDefault();
          await redirectToPinLockForKids();
        }
      }
    },
    {
      path: routes.brands1,
      name: "tryPremium",
      icon: "tryPremium",
      show: !subscriptionInactive && !isKids,
      visibleOnMenuExpand: true,
      separator: !subscriptionInactive ? (userLogged ? true : false) : false,
      callback: function() {
        if (this.props?.history?.location?.pathname) {
          this.props.stateActions.setSecLevelMenuPrevPath(this.props?.history?.location?.pathname);
        }
      },
      seperatorBottom: "-1rem",
      showInSection: 1
    },
    {
      path: routes.loginOrSignup,
      icon: "user",
      show: !userLogged,
      separator: true,
      name: "login",
      listStyle: "large",
      // name: "login",
      // icon: "user",
      // show: !userLogged,
      separator: true,
      // showModal: true,
      // showNotLoggedModal: true,
      // callback: function() {
      //   showNotLoggedModal.call(this, getNavigationReferences.call(this), this.closeModal);
      // },
      visibleOnMenuExpand: true,
      seperatorBottom: "-1rem",
      showInSection: 1
    }
  ];
  let secondSection = [
    {
      path: routes.search,
      name: sections.SEARCH,
      icon: "search",
      iconDescription: "Search icon",
      sticky: true,
      listStyle: "medium",
      callback: function() {
        trackEvent("search|new", "open", this.props.history.location.pathname);
      },
      showInSection: 2
    },
    {
      path: routes.home,
      name: sections.HOME,
      icon: "home",
      background: `${config.get().ui.urlCdn}/MainMenu/home.jpg`,
      // show: !isKids,
      listStyle: "medium",
      showInSection: 2
    },
    {
      path: routes.admn,
      name: sections.ADMN,
      icon: "admn",
      background: ``,
      // show: !isKids && isTizenNewModel(),
      show: !isLowEndLG(),
      listStyle: "medium",
      showInSection: 2
    },
    {
      path: routes.live,
      icon: "liveIcon",
      name: sections.LIVE,
      lockIconShouldAppear: true,
      background: `${config.get().ui.urlCdn}/MainMenu/live.jpg`,
      // show: !isKids,
      listStyle: "medium",
      showInSection: 2
    },
    {
      path: routes.freeTV,
      name: sections.FREETV,
      icon: "freeTV",
      background: `${config.get().ui.urlCdn}/MainMenu/freemium.jpg`,
      // show: !isKids && isTizenNewModel(),
      show: !isLowEndLG() && !getAppState().isSvodUser,
      listStyle: "medium",
      showInSection: 2
    },

    {
      path: routes.sports,
      name: sections.SPORTS,
      icon: "sports",
      background: `${config.get().ui.urlCdn}/MainMenu/sports.jpg`,
      show: !isKids,
      listStyle: "medium",
      showInSection: 2
    },
    {
      path: routes.wct2026,
      name: sections.WCT2026,
      icon: "wct",
      background: `${config.get().ui.urlCdn}/MainMenu/championstrophy2026.jpg`,
      show: getAppState().globalConfig?.isChampionsTrophyEnabled && !isLowEndLG() ? true : false,
      listStyle: "medium",
      showInSection: 2
    },
    {
      path: routes.store,
      name: sections.STORE,
      icon: "store",
      background: `${config.get().ui.urlCdn}/MainMenu/home.jpg`,
      show: !isKids,
      listStyle: "medium",
      showInSection: 2
    }
  ];
  if (isKids) {
    secondSection = [
      {
        path: routes.search,
        name: sections.SEARCH,
        icon: "search",
        iconDescription: "Search icon",
        sticky: true,
        listStyle: "medium",
        callback: function() {
          trackEvent("search|new", "open", this.props.history.location.pathname);
        },
        showInSection: 2
      },
      {
        path: routes.home,
        name: sections.HOME,
        icon: "home",
        background: `${config.get().ui.urlCdn}/MainMenu/home.jpg`,
        // show: !isKids,
        listStyle: "medium",
        showInSection: 2
      },
      {
        path: routes.admn,
        name: sections.ADMN,
        icon: "admn",
        background: ``,
        show: !isLowEndLG(),
        listStyle: "medium",
        showInSection: 2
      },
      {
        path: routes.freeTV,
        name: sections.FREETV,
        icon: "freeTV",
        background: `${config.get().ui.urlCdn}/MainMenu/freemium.jpg`,
        show: !isLowEndLG() && !getAppState().isSvodUser,
        listStyle: "medium",
        showInSection: 2
      },

      {
        path: routes.live,
        icon: "liveIcon",
        name: sections.LIVE,
        lockIconShouldAppear: true,
        background: `${config.get().ui.urlCdn}/MainMenu/live.jpg`,
        listStyle: "medium",
        showInSection: 2
      }
    ];
  }
  const thirdSection = [
    {
      path: routes.categoriesMenuPage,
      icon: "myList",
      show: !isKids,
      name: "categoriesModalTitle",
      listStyle: "large",
      // name: "categoriesModalTitle",
      icon: "myList",
      // separator: true,
      show: !isKids,
      showModal: true,
      showCategoriesModal: true,
      // callback: function() {
      //   showCategoriesMenuModal.call(this, getNavigationReferences.call(this), this.closeModal);
      // },
      showInSection: 2
    },
    {
      path: routes.mylibrary,
      name: sections.MYLIBARAY,
      lockIconShouldAppear: true,
      sticky: false,
      listStyle: "small",
      takeIconSpace: true,
      visibleOnMenuExpand: true,
      separator: true,
      seperatorBottom: "3rem",
      callback: function() {
        if (this.props?.history?.location?.pathname) {
          this.props.stateActions.setSecLevelMenuPrevPath(this.props?.history?.location?.pathname);
        }
      },
      showInSection: 3
    },
    {
      path: routes.settings,
      name: "myaccount",
      sticky: false,
      listStyle: "small",
      takeIconSpace: true,
      visibleOnMenuExpand: true,
      showInSection: 3
    },
    {
      path: routes.exitAppPage,
      name: "exitsp",
      sticky: false,
      listStyle: "small",
      showModal: true,
      showExitModal: true,
      // callback: function() {
      //   showAppExitConfirmationModal.call(this, this.closeModal);
      // },
      takeIconSpace: true,
      visibleOnMenuExpand: true,
      showInSection: 3
    }
  ];
  const menuItems = [...firstSection, ...secondSection, ...thirdSection];
  return menuItems
    .filter(item => (item.show !== undefined ? item.show : true))
    .map(filtered => ({
      ...filtered,
      isRoot: filtered.path ? getRouteByPath(filtered.path).isRoot : true
    }));
}

export const customSettings = {
  discovery: {
    iconWidth: "5vw",
    iconHeight: "4vw"
  },
  ufc: {
    iconWidth: "5vw",
    iconHeight: "5vw"
  },
  blutv: {
    iconWidth: "5vw",
    iconHeight: "5vw"
  },
  fifa: {
    iconWidth: "5vw",
    iconHeight: "5vw"
  },
  premiersports: {
    iconWidth: "5vw",
    iconHeight: "5vw"
  },
  adsports: {
    iconWidth: "7vw",
    iconHeight: "7vw"
  },
  criclife: {
    iconWidth: "7vw",
    iconHeight: "4vw"
  },
  majidtv: {
    iconWidth: "5vw",
    iconHeight: "4vw"
  },
  golftv: {
    iconWidth: "7vw",
    iconHeight: "7vw"
  }
};
/**
 * Returns the menu items to be shown in the categories full-screen menu.
 * Requires this instance, redirectTo and historyMethods to be passed as parameters.
 */
export function secondLevelMenu(thisInstance, redirectTo, historyMethods, i18n) {
  const SECOND_LEVEL_MENUBUTTON_TOP_SPACING = "1.666666rem";
  return [
    {
      label: i18n.get("global.sections.brands"),
      focusPath: "menu_brands_passThru",
      buttonHandler: redirectTo.bind(
        thisInstance,
        routes.brands,
        {
          ...{ backDestination: thisInstance?.props?.location?.pathname }
        },
        historyMethods.REPLACE
      ),
      isMarginTop: true,
      customMarginTop: "3rem",
      customWidth: "27rem"
    },
    {
      label: i18n.get("global.sections.movies"),
      focusPath: "menu_movies_passThru",
      buttonHandler: redirectTo.bind(thisInstance, routes.movies, null, historyMethods.REPLACE),
      customMarginTop: SECOND_LEVEL_MENUBUTTON_TOP_SPACING,
      customWidth: "27rem"
    },
    {
      label: i18n.get("global.sections.series"),
      focusPath: "menu_series_passThru",
      buttonHandler: redirectTo.bind(thisInstance, routes.series, null, historyMethods.REPLACE),
      customMarginTop: SECOND_LEVEL_MENUBUTTON_TOP_SPACING,
      customWidth: "27rem"
    },
    {
      label: i18n.get("global.sections.arabic"),
      focusPath: "menu_arabic_passThru",
      buttonHandler: redirectTo.bind(thisInstance, routes.arabic, null, historyMethods.REPLACE),
      customMarginTop: SECOND_LEVEL_MENUBUTTON_TOP_SPACING,
      customWidth: "27rem"
    },
    {
      label: i18n.get("global.sections.kids"),
      focusPath: "menu_kids_passThru",
      buttonHandler: redirectTo.bind(thisInstance, routes.kids, null, historyMethods.REPLACE),
      customMarginTop: SECOND_LEVEL_MENUBUTTON_TOP_SPACING,
      customWidth: "27rem"
    }
  ];
}
